module.exports = global["jQuery"] = require("-!/opt/app/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 9
// module chunks = 4